export const FinalQuoteColumns: any = [
  { text: '見積件名', value: 'estimate_subject', width: '150'},
  { text: '見積版名', value: 'estimate_version_name', width: '200' }
];

export const MatterServiceTypeOAcolumnItems: any = [
  { text: '見積ファイル名', value: 'name' },
  { text: 'サイズ（byte）', value: 'size' }
];

export const FinalQuoteOutputData: Array<{ [key: string]: any }> = [
  { label: '', name: 'id', isDisabled: true, value: '' },
  { label: '', name: 'estimate_subject', isDisabled: true, value: '' }
];

export const SearchLargeItem: any = {
  findItemName:'estimate_subject',
  setItemValue:'estimate_subject',
  setItemText:'estimate_subject',
  labelText: '見積件名'
}

export const SearchSmallItem: any = {
  findItemName:'estimate_version_name',
  setItemValue:'estimate_version_name',
  setItemText:'estimate_version_name',
  labelText: '見積版名'
}

export const EstimateBasicFileColumnItems = [
  { text: '見積ファイル名', value: 'name' },
  { text: 'サイズ（byte）', value: 'size' }
];

export const ButtonItems = [
  {
      'alwaysDisplayed': false,
      'class': "",
      'icon': "mdi-comment-text-outline",
      'name': "selectButtonIndex",
      'text': "選択"
  }
]